export const sysName = 'rehabilitation' //网站标题
export const sysBase = sysName // url base
export const sysBaseOfMobile = `${sysName}-mobile`
export const title = `康复师X`
export const tokenLocalStorageExpires = 1 //记住密码状态下的token在LocalStorage中存储的天数
export const passLocalStorageExpires = 1 //记住密码状态下的密码在LocalStorage中存储的天数
export const ThemeKey = `${sysName}-theme` // 主题色 key
export const TokenKey = `${sysName}Token` // localStorage 存储的key
export const TokenKeyOfHeader = 'auth-token' // 请求头的 key
export const publicKey =
	'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCZrizglLM2tQ7R+zHQTy6YhmIvCrNztn7y8ahLd8/YBpiy9bSHo/iAvwOtcGN3BAD+YqFhUyKlY0q4rAubzhX7ShBC70t/s9q07L267rWr/9ZW8cDFvBFeoyySkmaZT4KDIwvpKHBzy9LQ1UJ+AlL98OxtvoDwIuVawYtwE23eYwIDAQAB'
export const timeout = 1200000 // 请求超时时间，毫秒（默认2分钟）

export default {
	sysName,
	sysBase, // url base
	sysBaseOfMobile,
	title,
	tokenLocalStorageExpires,
	passLocalStorageExpires,
	ThemeKey, // 主题色 key
	TokenKey, // localStorage 存储的key
	TokenKeyOfHeader, // 请求头的 key
	publicKey,
	timeout,
}
